(() => {
  const pair = (fr, en) => ({ fr, en });
  const families = [];
  const add = (handles, labels, title, hint, axis = [], auxiliary = null) => {
    families.push({ handles, labels, title, hint, axis, auxiliary });
  };
  const soundPair = (handles, hint, labels = [pair('Sport', 'Sport'), pair('Super Sound', 'Super Sound')], axis = [pair('Sport', 'Sport'), pair('Plus sonore', 'Louder')]) => {
    add(handles, labels, pair('Le même silencieux, deux sonorités', 'The same muffler, two sound levels'), hint, axis);
  };
  const controlPair = (handles, hint, first = pair('Sport', 'Sport')) => {
    add(
      handles,
      [first, pair('Valves fermées / ouvertes', 'Valves closed / open')],
      pair('La même pièce, deux comportements', 'The same part, two behaviours'),
      hint,
      [pair('Sans commande', 'Uncontrolled'), pair('À la demande', 'On demand')]
    );
  };
  const finishFamily = (handles, labels, title, hint) => add(handles, labels, title, hint);

  add(
    [
      'pr-silencieux-2-en-1-flux-optimis-sonorit-douce',
      'pr-silencieux-2-en-1-sonorit-sport-type-riva-best-seller',
      'pr-silencieux-2-en-1-racing-sonorit-super-sound',
    ],
    [pair('Sonorité douce', 'Soft sound'), pair('Riva', 'Riva'), pair('Racing', 'Racing')],
    pair('La même pièce, trois sonorités', 'The same part, three sound levels'),
    pair('la forme fait le son', 'shape makes the sound'),
    [pair('Discret', 'Subtle'), pair('Sonore', 'Loud')],
    {
      handles: ['pr-silencieux-2-en-1-catalys-standard-300cc', 'pr-silencieux-2-en-1-catalys-sport-100cc'],
      labels: [pair('Catalysé standard 300 cellules', 'Standard 300-cell catalyst'), pair('Catalysé sport 100 cellules', 'Sport 100-cell catalyst')],
      title: pair('Les mêmes, avec catalyseur', 'The same parts, with a catalyst'),
      axis: [pair("Proche de l'origine", 'Close to stock'), pair('Plus sportif', 'Sportier')],
    }
  );

  add(
    ['silencieux-2-entrees-1-sortie-sonorite-sport', 'silencieux-2-entr-es-1-sortie-sonorit-riva'],
    [pair('Sport', 'Sport'), pair('Riva', 'Riva')],
    pair('La même pièce, deux sonorités', 'The same part, two sound levels'),
    pair('une sortie arrière', 'single rear outlet'),
    [pair('Civilisé', 'Civilised'), pair('Plus expressif', 'More expressive')]
  );
  soundPair(
    ['silencieux-2-entrees-2-sorties-centrees-70mm-sonorite-sport', 'silencieux-2-entrees-2-sorties-arrieres-70mm-sonorite-super-sound'],
    pair('deux sorties centrées', 'twin centre outlets'),
    [pair('Sport', 'Sport'), pair('Super Sound', 'Super Sound')],
    [pair('Plus sage', 'More restrained'), pair('Plus sportif', 'Sportier')]
  );
  soundPair(
    ['silencieux-2-entr-es-2-sorties-d-g-sonorit-sport', 'silencieux-2-entr-es-2-sorties-d-g-sonorit-super-sound'],
    pair('sorties gauche et droite', 'left and right outlets'),
    undefined,
    [pair('Plus sage', 'More restrained'), pair('Plus sonore', 'Louder')]
  );
  soundPair(
    ['silencieux-sport-type-banane-pour-911-2-7-3-0l-sonorit-sport', 'silencieux-pour-911-2-7l-3-0l-sonorit-super-sound-type-riva-best-seller'],
    pair('2,7 L et 3,0 L', '2.7 L and 3.0 L'),
    [pair('Sport', 'Sport'), pair('Riva', 'Riva')],
    [pair('Intermédiaire', 'Balanced'), pair('Plus profond', 'Deeper')]
  );
  soundPair(
    ['silencieux-sport-type-banane-pour-911-3-2l-sonorit-sport', 'silencieux-pour-911-3-2l-sonorit-super-sound-type-riva-best-seller'],
    pair('3,2 L Carrera', '3.2 L Carrera'),
    [pair('Sport', 'Sport'), pair('Riva', 'Riva')],
    [pair('Intermédiaire', 'Balanced'), pair('Plus profond', 'Deeper')]
  );
  soundPair(['silencieux-sport-pour-911-2-7l-rs', 'silencieux-super-sound-pour-911-2-7l-rs'], pair('911 2,7 L RS', '911 2.7 L RS'));
  soundPair(['silencieux-sport-1-7l', 'silencieux-super-sound-1-7l'], pair('914/4 1,7 L', '914/4 1.7 L'));
  soundPair(['silencieux-sport-2-0l', 'silencieux-super-sound-2-0l'], pair('914/4 2,0 L', '914/4 2.0 L'));
  soundPair(
    ['echappement-sport-porsche-912e', 'echappement-super-sound-type-riva-porsche-912e'],
    pair('Porsche 912E', 'Porsche 912E'),
    [pair('Sport', 'Sport'), pair('Riva', 'Riva')]
  );
  soundPair(['silencieux-sport-sonorit-sport', 'silencieux-sport-sonorit-super-sound'], pair('Turbo 3,0 L', '3.0 L Turbo'));
  soundPair(
    ['silencieux-sport-sorties-jointes', 'silencieux-super-sound'],
    pair('Turbo 3,3 L', '3.3 L Turbo'),
    [pair('Sport', 'Sport'), pair('Super Sound', 'Super Sound')],
    [pair("Proche de l'origine", 'Close to stock'), pair('Plus sonore', 'Louder')]
  );

  add(
    ['catalyseur-standard-300-cc-porsche-964', 'catalyseur-sport-100cc-porsche-964', 'catalyseur-by-pass-sport-porsche-964', 'catalyseur-by-pass-racing'],
    [pair('Standard 300 cellules', 'Standard 300-cell'), pair('Sport 100 cellules', 'Sport 100-cell'), pair('By-pass Sport', 'Sport bypass'), pair('By-pass Racing', 'Racing bypass')],
    pair('Le même emplacement, quatre caractères', 'The same position, four characters'),
    pair('catalyseur ou by-pass', 'catalyst or bypass'),
    [pair("Proche de l'origine", 'Close to stock'), pair('Le plus radical', 'Most radical')]
  );
  add(
    ['catalyseur-standard-300-cellules', 'catalyseur-sport-100-cellules', 'catalyseur-by-pass-racing-porsche-964-turbo'],
    [pair('Standard 300 cellules', 'Standard 300-cell'), pair('Sport 100 cellules', 'Sport 100-cell'), pair('By-pass Racing', 'Racing bypass')],
    pair('Le même emplacement, trois caractères', 'The same position, three characters'),
    pair('964 Turbo', '964 Turbo'),
    [pair("Proche de l'origine", 'Close to stock'), pair('Le plus radical', 'Most radical')]
  );
  add(
    ['tube-cup', 'echappement-sport-riva', 'echappement-a-valve-porsche-964'],
    [pair('Tube CUP', 'CUP pipe'), pair('Riva', 'Riva'), pair('Valves fermées / ouvertes', 'Valves closed / open')],
    pair('Le même emplacement, trois réponses', 'The same position, three responses'),
    pair('silencieux primaire', 'primary muffler'),
    [pair('Direct', 'Direct'), pair('Progressif', 'Progressive'), pair('Pilotable', 'Driver-controlled')]
  );
  soundPair(
    ['silencieux-arri-re-droit-version-sport', 'silencieux-arri-re-droit-version-super-sound'],
    pair('silencieux secondaire', 'secondary muffler'),
    [pair('Sport', 'Sport'), pair('Super Sound', 'Super Sound')],
    [pair("Son proche de l'origine", 'Close to stock'), pair('Puissant et profond', 'Powerful and deep')]
  );
  add(
    ['sortie-ovale', 'sortie-avec-ourlet-90mm-insert'],
    [pair("Ovale d'origine", 'Stock-style oval'), pair('90 mm avec insert', '90 mm with insert')],
    pair('Le même emplacement, deux sorties', 'The same position, two outlets'),
    pair('forme et fonction', 'shape and function'),
    [pair("Finition d'origine", 'Stock finish'), pair('Atténuation amovible', 'Removable attenuation')]
  );
  soundPair(['ligne-d-chappements-1-sortie-sonorit-sport', 'ligne-d-chappements-racing-1-sortie-sonorit-super-sound'], pair('ligne Racing, une sortie', 'Racing system, single outlet'));
  soundPair(['ligne-d-chappements-2-sorties-sonorit-sport', 'ligne-d-chappements-racing-2-sorties-sonorit-super-sound'], pair('ligne Racing, deux sorties', 'Racing system, twin outlets'));
  soundPair(['syst-me-cup-2-sorties-sonorit-sport', 'syst-me-cup-2-sorties-super-sound'], pair('système CUP, deux sorties', 'CUP system, twin outlets'));

  const catalyst993 = (handles, hint) => add(
    handles,
    [pair('Standard 300 cellules', 'Standard 300-cell'), pair('Sport 100 cellules', 'Sport 100-cell'), pair('Racing by-pass', 'Racing bypass')],
    pair('Le même catalyseur, trois caractères', 'The same catalyst, three characters'),
    hint,
    [pair("Proche de l'origine", 'Close to stock'), pair('Le plus radical', 'Most radical')]
  );
  catalyst993(['catalyseur-standard-300-cc-bischoff', 'catalyseur-sport-100-cc-bischoff', 'catalyseur-racing-by-pass-bischoff'], pair('montage Bischoff', 'Bischoff fitment'));
  catalyst993(['catalyseur-standard-300-cc-gillet', 'catalyseur-sport-100-cc-gillet', 'catalyseur-racing-by-pass-gillet'], pair('montage Gillet', 'Gillet fitment'));
  controlPair(['silencieux-riva', 'echappement-a-valves-porsche-993'], pair('993 Carrera', '993 Carrera'), pair('Riva', 'Riva'));
  controlPair(['silencieux-sport-riva', 'silencieux-valves-commande-par-interrupteur'], pair('993 Turbo', '993 Turbo'), pair('Riva', 'Riva'));

  soundPair(
    ['echappement-sport-sonorite-douce-porsche-996-3-4l-et-3-6l-et-gt3', 'echappement-sport-ultima-recital-porsche-996-3-4l-3-6l-et-gt3'],
    pair('996 3,4 L et 3,6 L', '996 3.4 L and 3.6 L'),
    [pair('Sonorité douce', 'Soft sound'), pair('Ultima Récital', 'Ultima Recital')],
    [pair('Douce', 'Soft'), pair('Plus expressive', 'More expressive')]
  );
  controlPair(['silencieux-sport-sortie-double', 'silencieux-sport-valves-commande-par-interrupteur-sortie-double'], pair('Boxster 986', 'Boxster 986'));
  controlPair(['echappement-sport-ultima-porsche-987', 'echappement-a-valves-porsche-987'], pair('Boxster 987', 'Boxster 987'), pair('Ultima', 'Ultima'));
  controlPair(['echappement-sport-ultima-porsche-987-2', 'echappement-a-valves-porsche-987-2'], pair('Boxster 987 phase 2', 'Boxster 987 phase 2'), pair('Ultima', 'Ultima'));
  controlPair(['sport-ultima-r-cital', 'echappement-a-valves-porsche-981'], pair('Boxster 981', 'Boxster 981'), pair('Ultima Récital', 'Ultima Recital'));
  controlPair(['echappement-sport-ultima-porsche-944-turbo', 'echappement-a-valve-porsche-944-turbo'], pair('944 Turbo', '944 Turbo'), pair('Ultima', 'Ultima'));
  controlPair(['silencieux-sport-avec-sortie', 'echappement-a-valve-porsche-968'], pair('Porsche 968', 'Porsche 968'));
  controlPair(['echappements-sport-catalyseurs-silencieux', 'echappement-sport-a-valves-porsche-997-turbo'], pair('997 Turbo', '997 Turbo'));
  controlPair(
    ['catalyseurs-200-cellules-silencieux', 'echappement-sport-interrupteur'],
    pair('996 Turbo', '996 Turbo'),
    pair('Sport · 200 cellules', 'Sport · 200-cell')
  );

  add(
    ['catalyseurs-200cc-2-7l-3-2l', 'catalyseurs-by-pass-porsche-986-2-7l-3-2l'],
    [pair('Catalysé 200 cellules', 'Catalysed 200-cell'), pair('By-pass', 'Bypass')],
    pair('Le même emplacement, deux configurations', 'The same position, two configurations'),
    pair('Boxster 2,7 L et 3,2 L', 'Boxster 2.7 L and 3.2 L'),
    [pair('Catalysé', 'Catalysed'), pair('Flux le plus direct', 'Most direct flow')]
  );
  add(
    ['catalyseur-sport-200cc-porsche-968', 'catalyseur-by-pass-avec-silencieux'],
    [pair('Sport 200 cellules', 'Sport 200-cell'), pair('By-pass avec silencieux', 'Bypass with silencer')],
    pair('Le même emplacement, deux configurations', 'The same position, two configurations'),
    pair('Porsche 968', 'Porsche 968'),
    [pair('Catalysé', 'Catalysed'), pair('Flux le plus direct', 'Most direct flow')]
  );
  add(
    ['catalyseurs-standard-300cc', 'catalyseurs-sport-200-cellules-pour-porsche-997'],
    [pair('Standard 300 cellules', 'Standard 300-cell'), pair('Sport 200 cellules', 'Sport 200-cell')],
    pair('Le même catalyseur, deux caractères', 'The same catalyst, two characters'),
    pair('Porsche 997', 'Porsche 997'),
    [pair("Proche de l'origine", 'Close to stock'), pair('Plus sportif', 'Sportier')]
  );
  soundPair(
    ['silencieux-sport-classic', 'silencieux-sport-ultima-r-cital'],
    pair('Porsche 997', 'Porsche 997'),
    [pair('Sport Classic', 'Sport Classic'), pair('Ultima Récital', 'Ultima Recital')],
    [pair('Sport', 'Sport'), pair('Plus expressif', 'More expressive')]
  );

  add(
    ['echappement-sport-ferrari-f430', 'silencieux-racing'],
    [pair('Sport', 'Sport'), pair('Racing', 'Racing')],
    pair('Le même emplacement, deux sonorités', 'The same position, two sound levels'),
    pair('Ferrari F430', 'Ferrari F430'),
    [pair('Sport', 'Sport'), pair('Le plus radical', 'Most radical')],
    {
      handles: ['silencieux-valves'],
      labels: [pair('Valves fermées / ouvertes', 'Valves closed / open')],
      title: pair('Ou le son à la demande', 'Or sound on demand'),
      axis: [],
    }
  );
  controlPair(['silencieux-sport-pour-audi-r8-v8', 'silencieux-valves-pour-audi-r8-v8'], pair('Audi R8 V8', 'Audi R8 V8'));
  controlPair(['echappement-sport-pour-audi-r8-v10', 'silencieux-valves-pour-audi-r8-v10'], pair('Audi R8 V10', 'Audi R8 V10'));
  controlPair(['echappement-sport-porsche-955-s', 'echappement-sport-a-valves-porsche-955-s'], pair('Cayenne 955 S', 'Cayenne 955 S'));
  controlPair(['echappements-sport-porsche-955-turbo', 'silencieux-sport-avec-valves-commande-par-interrupteur'], pair('Cayenne 955 Turbo', 'Cayenne 955 Turbo'));
  controlPair(['echappement-sport-porsche-cayenne-957-s', 'echappement-sport-a-valves-porsche-957-s'], pair('Cayenne 957 S', 'Cayenne 957 S'));
  controlPair(['echappement-sport-porsche-957-turbo', 'echappements-a-valves-porsche-957'], pair('Cayenne 957 Turbo', 'Cayenne 957 Turbo'));
  controlPair(['echappement-sport-porsche-958', 'echappements-sport-a-valves-porsche-958'], pair('Cayenne 958', 'Cayenne 958'));
  controlPair(['echappement-sport-porsche-958-turbo', 'silencieux-sport-avec-valve-commande-par-interrupteur'], pair('Cayenne 958 Turbo', 'Cayenne 958 Turbo'));
  controlPair(['silencieux-sport-panamera-970-turbo', 'echappement-sport-a-valves-porsche-panamera-970-turbo'], pair('Panamera 970 Turbo', 'Panamera 970 Turbo'));

  finishFamily(
    ['sortie-chrom-e-origine-porsche', 'sortie-noire-origine'],
    [pair('Chromée', 'Chrome'), pair('Noire', 'Black')],
    pair('La même sortie, deux finitions', 'The same outlet, two finishes'),
    pair('finition extérieure', 'exterior finish')
  );
  finishFamily(
    ['paire-de-sortie-chrom-es', 'paire-de-sortie-bross-es'],
    [pair('Chromées', 'Chrome'), pair('Brossées', 'Brushed')],
    pair('Les mêmes sorties, deux finitions', 'The same outlets, two finishes'),
    pair('sorties simples', 'single outlets')
  );
  finishFamily(
    ['paire-de-sorties-double-2x88-chrom-e', 'paire-de-sorties-double-2x88-bross-e', 'paire-de-sorties-double-2x88-noire'],
    [pair('Chromées', 'Chrome'), pair('Brossées', 'Brushed'), pair('Noires', 'Black')],
    pair('Les mêmes sorties, trois finitions', 'The same outlets, three finishes'),
    pair('double 2 × 88 mm', 'twin 2 × 88 mm')
  );
  finishFamily(
    ['sorties-pse-double-chrom-e', 'sorties-double-bross-es', 'sorties-double-pse-noir-mat'],
    [pair('Chromées', 'Chrome'), pair('Brossées', 'Brushed'), pair('Noir mat', 'Matt black')],
    pair('Les mêmes sorties, trois finitions', 'The same outlets, three finishes'),
    pair('997 phase 2 PSE', '997 phase 2 PSE')
  );
  finishFamily(
    ['paire-de-sortie-chrom', 'paire-de-sorties-bross-es'],
    [pair('Chromées', 'Chrome'), pair('Brossées', 'Brushed')],
    pair('Les mêmes sorties, deux finitions', 'The same outlets, two finishes'),
    pair('991 PSE', '991 PSE')
  );
  finishFamily(
    ['sortie-double-biseaut-e-2x88-chrom-e', 'sorties-double-black-c-ramique-grand-diam-tre-2x88'],
    [pair('Chromée biseautée', 'Bevelled chrome'), pair('Noire céramique', 'Ceramic black')],
    pair('Le même emplacement, deux sorties', 'The same position, two outlets'),
    pair('Boxster 987', 'Boxster 987')
  );

  const productCache = new Map();
  const localeKey = document.documentElement.lang.toLowerCase().startsWith('fr') ? 'fr' : 'en';
  const localise = (value) => value?.[localeKey] || value?.fr || '';

  function findFamily(handle) {
    return families.find((family) => family.handles.includes(handle) || family.auxiliary?.handles.includes(handle));
  }

  function productUrl(root, handle) {
    const prefix = root.endsWith('/') ? root : `${root}/`;
    return `${prefix}products/${encodeURIComponent(handle)}.js`;
  }

  function loadProduct(root, handle) {
    const key = `${root}:${handle}`;
    if (!productCache.has(key)) {
      productCache.set(
        key,
        fetch(productUrl(root, handle), { headers: { Accept: 'application/json' } }).then((response) => {
          if (!response.ok) throw new Error(`Product ${handle}: ${response.status}`);
          return response.json();
        })
      );
    }
    return productCache.get(key);
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
        style: 'currency',
        currency: currency || 'EUR',
        maximumFractionDigits: 2,
      }).format(Number(cents) / 100);
    } catch (_) {
      return `${(Number(cents) / 100).toFixed(2)} ${currency || 'EUR'}`;
    }
  }

  function imageSource(data) {
    if (typeof data.featured_image === 'string') return data.featured_image;
    if (data.featured_image?.url) return data.featured_image.url;
    const first = data.images?.[0];
    return typeof first === 'string' ? first : first?.src || '';
  }

  function scaleMarkup(axis, extraClass = '') {
    if (!axis?.length) return '';
    const label = axis.map(localise).join(', ');
    const content = axis.map((item, index) => `${index ? '<i aria-hidden="true"></i>' : ''}<span>${localise(item)}</span>`).join('');
    return `<p class="scfp__scale ${extraClass}" aria-label="${label}">${content}</p>`;
  }

  function cardMarkup(handle, label, current, compact, root) {
    const currentClass = current ? ' is-current' : '';
    const currentAttribute = current ? ' aria-current="page"' : '';
    const flag = current ? `<span class="scfp__flag">${localeKey === 'fr' ? 'votre pièce' : 'your part'}</span>` : '';
    const visualClass = compact ? 'scfp__cat-visual' : 'scfp__visual';
    const content = compact
      ? `<span class="${visualClass}" data-scfp-visual></span><span><strong>${localise(label)}</strong><span data-scfp-price></span></span>${flag}`
      : `<span class="${visualClass}" data-scfp-visual></span><span class="scfp__name">${localise(label)}</span><span class="scfp__price" data-scfp-price></span>${flag}`;
    return `<a class="${compact ? 'scfp__cat' : 'scfp__cell'}${currentClass}" href="${root}products/${handle}" data-scfp-card data-handle="${handle}"${currentAttribute}>${content}</a>`;
  }

  function render(root, family) {
    const current = root.dataset.scfpHandle;
    const routeRoot = root.dataset.scfpRoot.endsWith('/') ? root.dataset.scfpRoot : `${root.dataset.scfpRoot}/`;
    const columns = family.handles.length;
    const cards = family.handles.map((handle, index) => cardMarkup(handle, family.labels[index], handle === current, false, routeRoot)).join('');
    let html = `<p class="scfp__head"><span class="scfp__title">${localise(family.title)}</span><span class="scfp__hint">${localise(family.hint)}</span></p>`;
    html += `<div class="scfp__row" style="--scfp-columns:${columns};--scfp-mobile-columns:${Math.min(columns, 2)}">${cards}</div>`;
    html += scaleMarkup(family.axis);
    if (family.auxiliary) {
      const auxiliaryCards = family.auxiliary.handles.map((handle, index) => cardMarkup(handle, family.auxiliary.labels[index], handle === current, true, routeRoot)).join('');
      html += `<div class="scfp__cats"><p class="scfp__cats-label">${localise(family.auxiliary.title)}</p><div class="scfp__cats-row" style="--scfp-aux-columns:${family.auxiliary.handles.length}">${auxiliaryCards}</div>${scaleMarkup(family.auxiliary.axis, 'scfp__scale--aux')}</div>`;
    }
    root.innerHTML = html;
    root.hidden = false;
  }

  function hydrateCard(card, data, currency, placeholder) {
    const visual = card.querySelector('[data-scfp-visual]');
    const source = imageSource(data) || placeholder;
    if (visual && source) {
      const image = document.createElement('img');
      image.src = source;
      image.alt = data.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      visual.replaceChildren(image);
    }
    const price = card.querySelector('[data-scfp-price]');
    if (price && Number.isFinite(Number(data.price))) price.textContent = formatMoney(data.price, currency);
  }

  function initFamily(root) {
    if (root.dataset.scfpReady === 'true') return;
    root.dataset.scfpReady = 'true';
    const family = findFamily(root.dataset.scfpHandle);
    if (!family) return;
    render(root, family);
    const routeRoot = root.dataset.scfpRoot || '/';
    const currency = root.dataset.scfpCurrency || window.Shopify?.currency?.active || 'EUR';
    const placeholder = root.dataset.scfpPlaceholder || '';
    root.querySelectorAll('[data-scfp-card]').forEach((card) => {
      loadProduct(routeRoot, card.dataset.handle)
        .then((data) => hydrateCard(card, data, currency, placeholder))
        .catch(() => card.classList.add('is-unavailable'));
    });
  }

  function init() {
    document.querySelectorAll('[data-scfp-product-family]').forEach(initFamily);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
